import { render } from "./maxNumberOfReportsReachedPopup.vue?vue&type=template&id=56f0ef6b&lang=pug"
import script from "./maxNumberOfReportsReachedPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./maxNumberOfReportsReachedPopup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__